import React from 'react';
import {
	StyledH2,
} from './style';

export const BriefingTitleRow = ({ children }) => (
	<div className="row" style={{ marginBottom: '25px' }}>
		<div className="col-12">
			<StyledH2>{children}</StyledH2>
		</div>
	</div>
);
